export default __webpack_public_path__ + "static/media/Medical Treatment.b033a4c4.jpg";